import type { ReactNode } from 'react';

import { useInView } from 'src/hooks/use-in-view';
import { mergeClasses } from 'src/utils/merge-classes';

type RevealProps = {
  children: ReactNode;
  className?: string;
};

export function Reveal({ children, className }: RevealProps) {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <div ref={ref} className={mergeClasses('reveal', inView && 'visible', className)}>
      {children}
    </div>
  );
}
